class LegacyExperienceDataProvider {
  constructor(indexData) {
    this.indexData = indexData;
  }
  async getDistribution() {
    return await Promise.resolve(this.indexData.config.data.distribution);
  }
  async getActivations() {
    return await Promise.resolve(this.indexData.config.events);
  }
  async getSettings() {
    return await Promise.resolve(this.indexData.config.settings);
  }
  async getTags() {
    return await Promise.resolve(this.indexData.config.tags ?? []);
  }
  async getOrganization() {
    return await Promise.resolve(this.indexData.config.data.organization);
  }
}
class LegacyExperiencePlayerTemplateProvider {
  constructor(indexData) {
    this.indexData = indexData;
  }
  async getDefaultMedia() {
    return await Promise.resolve(this.indexData.config.content.media);
  }
  async getPlayerTemplate() {
    var _a, _b, _c;
    const contentType = this.indexData.config.content.type;
    return await Promise.resolve(contentType === "dynamic" ? ((_c = (_b = (_a = this.indexData.config.settings) == null ? void 0 : _a.layout) == null ? void 0 : _b.template) == null ? void 0 : _c.type) ?? "" : contentType);
  }
}
export {
  LegacyExperienceDataProvider,
  LegacyExperiencePlayerTemplateProvider
};
